{
  "TODO": "TODO:",
  "account": "Account",
  "acreInches": "acre-inches",
  "acres": "acres",
  "action": "Action",
  "action_one": "Action",
  "action_other": "Actions",
  "actions": "Actions",
  "active": "Active",
  "alert": "Alert",
  "appbarLinks": {
    "deviceConnections": "Connections",
    "devices": "Devices",
    "fields": "Fields",
    "flowAnalytics": {
      "long": "Flow Analytics",
      "short": "Analytics"
    },
    "home": "Home",
    "schedules": "Schedules",
    "settings": "Settings"
  },
  "archived": "Archived",
  "asOfRelativeTime": "as of {{val, relativetime}}",
  "back": "Back",
  "cancel": "Cancel",
  "changeBtn": "Change",
  "changeFarmAccount": "Change Farm Account",
  "changesSaved": "Changes saved.",
  "charging": "Charging",
  "checkingForUpdates": "Checking for new updates...",
  "clickToEnlarge": "Click to enlarge",
  "close": "close",
  "codaDeviceAlias": "Device Alias",
  "code": "Code",
  "codeSent": "Code Sent",
  "companyName": "FarmHQ",
  "confirm": "Confirm",
  "confirmChanges": "Confirm Changes",
  "confirmationRequired": "Confirmation Required",
  "connections": "Connections",
  "contactUs": "Contact Us",
  "continue": "Continue",
  "copiedToClipboard": "Copied to clipboard.",
  "copy": "Copy",
  "copyEmailAddress": "Copy Email",
  "dataNotAvailable": "Data not available",
  "datepickersMaxDateTitle": "End",
  "datepickersMinDateTitle": "Start",
  "datepickersTitle": "Date Range",
  "datetimeWithVal": "{{val, datetime}}",
  "datetimeWithValAndTimezone": "{{val, datetime}} ({{timezone}})",
  "degrees": "degrees",
  "degreesWithVal": "{{val}}°",
  "delete": "Delete",
  "devOnly": "Dev Only",
  "deviceId": "ID",
  "deviceInstallationType": "Installation Type",
  "deviceInstallationTypes": {
    "center_pivot": "Center-Pivot",
    "center_pivot_controller": "Center-Pivot Controller",
    "center_pivot_monitor": "Center-Pivot Monitor",
    "linear_move": "Linear Move",
    "linear_move_controller": "Linear Move Controller",
    "linear_move_monitor": "Linear Move Monitor",
    "prototype": "Prototype",
    "pump": "Pump",
    "pump_off_only": "Pump (Off-Only)",
    "pump_on_off": "Pump (On/Off)",
    "pump_vfd": "Pump (VFD)",
    "reel": "Reel",
    "reel_with_booster_off_only": "Reel With Booster (Off-Only)",
    "traveller_soft": "Traveler (Soft Hose)",
    "unconfigured": "Unconfigured",
    "valve": "Valve"
  },
  "deviceLabelWithDeviceName": "Device: {{deviceName}}",
  "deviceName": "Device Name",
  "deviceNameWithDeviceInstallationType": "{{deviceName}} ({{deviceInstallationType}})",
  "deviceProfile": "Device Profile",
  "device_one": "Device",
  "device_other": "Devices",
  "devices": "Devices",
  "disabled": "disabled",
  "discharging": "Discharging",
  "dismiss": "dismiss",
  "doNotShowThisAgain": "Do not show this again",
  "done": "Done",
  "dragSlider": "Drag Slider",
  "dueEast": "Due East",
  "dueNorth": "Due North",
  "dueSouth": "Due South",
  "dueWest": "Due West",
  "edit": "edit",
  "emailUs": "Email Us",
  "enabled": "enabled",
  "end": "End",
  "event_one": "Event",
  "event_other": "Events",
  "example": "example",
  "exit": "Exit",
  "exitDemoMode": "Exit Demo Mode",
  "experimentalFeatureTitle": "Experimental Feature",
  "experimentalFeatureWarning": "This feature is experimental and may not be fully supported.",
  "expiresInRelativeTime": "Expires in {{value, relativetime}}",
  "false": "False",
  "farm": "farm",
  "farmLocation": "Farm Location",
  "farmScreenTitle": "Farm",
  "farmUserPermissionsTitle": "Farm-User Permissions",
  "field": "Field",
  "fieldWithCount_one": "field",
  "field_many": "Fields",
  "fields": "Fields",
  "fieldsWithCount_other": "fields",
  "filter": "Filter",
  "firmwareVersion": "Firmware Version",
  "flipSwath": "Flip",
  "forbidden": "Forbidden",
  "gettingDeviceActivity": "Getting device activity...",
  "gettingFarm": "Getting farm data...",
  "gettingUser": "Getting user data...",
  "good": "Good",
  "goToAnalyticsSite": "Analytics Portal",
  "help": "Help",
  "hint": "Hint",
  "home": "Home",
  "horizontal": "horizontal",
  "id": "ID",
  "lastCheckInWithFallback": "Last Check In: Over 24 hours ago",
  "lastCheckInWithVal": "Last Check In: {{val, relativetime}}",
  "loading": "Loading",
  "loadingEvents": "Loading Events...",
  "manage": "Manage",
  "menu": "Menu",
  "moderate": "Moderate",
  "more": "More",
  "new": "new",
  "newRule": "New Rule",
  "newer": "newer",
  "next": "Next",
  "no": "No",
  "noScheduledActions": "No actions scheduled",
  "none": "None",
  "notApplicable": "N/A",
  "notCharging": "Not Charging",
  "notFound": "Not Found",
  "notNow": "Not Now",
  "note": "Note",
  "noteWithColon": "Note:",
  "notificationsEnabled": "Notifications Enabled",
  "older": "Older",
  "ongoing": "Ongoing",
  "oops": "Oops",
  "or": "Or",
  "otpFieldLabel": "Enter code",
  "otpFieldPlaceholder": "XXXXXX",
  "pages": "Pages",
  "percentSign": "%",
  "percentWithVal": "{{val}}%",
  "poor": "Poor",
  "preparingDemo": "Preparing demo environment...",
  "previous": "Previous",
  "readonly": "read-only",
  "reelRun": "Reel Run",
  "reelRun_one": "Reel Run",
  "reelRun_other": "Reel Runs",
  "relativeTimeWithVal": "{{val, relativetime}}",
  "reportAProblem": "Report a Problem",
  "requestSentToDevice": "Request sent to device...",
  "resendCode": "Resend Code",
  "result": "Result",
  "reviewAndSubmit": "Review and Submit",
  "save": "save",
  "select": "Select",
  "selected": "selected",
  "self": "Self",
  "sensorNameWithLabel": "{{sensorName}} Sensor",
  "sensorWithSensorName": "{{sensorName}} Sensor",
  "sensor_many": "sensors",
  "sensor_one": "sensor",
  "settings": "Settings",
  "showLess": "Show Less",
  "showMore": "Show More",
  "signOut": "Sign Out",
  "skipForNow": "Skip for now",
  "offlineErrorMessage": "You're offline. Check your connection and try again.",
  "offlineIndicator": "Offline",
  "permissionDeniedErrorMessage": "You don't have permission to do this.",
  "somethingWentWrong": "Something went wrong.",
  "sort": "sort",
  "sourceDevice": "Source Device",
  "start": "Start",
  "startOver": "Start Over",
  "submit": "Submit",
  "success": "Success",
  "support": "Support",
  "targetDevice": "Target Device",
  "time": "Time",
  "true": "True",
  "undo": "undo",
  "unknown": "Unknown",
  "valWithColon": "{{val}}: ",
  "verifiedFalse": "Not Verified",
  "verifiedTrue": "Verified",
  "warning": "Warning",
  "welcome": "Welcome",
  "whyDoWeCollectThis": "Why do we collect this information?",
  "yes": "Yes"
}
